var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTache1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.82 46.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.18,33.59l-.42,3.71c-.1.91-1.85.2-4.23-.18-.17.57-.12,2.48.64,2.88l4.88,2.53c1.28,3.42-7.03,5.66-9.01,2.83C.04,39.63-1.15,34.55,1.2,28l6.18,1.71,4.59-5.17-3.93-7.55c-1.35-2.6-2.03-4.24-1.71-7.64L1.78,1.82l11.44-.77c-.54,2.42-1.11,3.47-.63,3.87,1.34,1.1,13.36,1.43,11.63,12.26-.2,1.26,1.1,4.3,1.71,4.86l6.51-5.57h-4.64c-.9,0-1.39-3.38-.79-4.03l4.74-5.07c3.05-1.73,5.08-3.88,6.67-7.37l6.88,1.39c-.54.6-1.36,1.76-1.94,1.64l-2.95-.64.43,7.92c.02.44.93,1.58,1.29,1.85s2.1-.27,1.94-.69l-1.45-3.96c-.43-1.18,2.96-1.82,4.53-1.72,2.6.17,4.01,13.46,3.68,17.12l3.56,4.46,1.4,7.44c.45.63-2.64,2.58-3.7,2.05l-5.25-2.6c1.69,3.31,2.77,5.65,1.1,9.7l-3.82-5.98-3.19.15c-.4.02-.38.58-.11.88l1.82,2.04-5.64,4.12c-1.62,0-5.8-2.37-7.39-3.64-.49-.39,1-3.03.4-3.18-9.29-2.25-6.13,2.69-11.34.99-2.06-.67-4.58-3.55-6.47-5.76Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTache1);
export default __webpack_public_path__ + "static/media/tache1.85655701d9c434c434104c459886b406.svg";
export { ForwardRef as ReactComponent };